export interface FeedbackReason {
  id: string;
  label: string;
}

/** Ordered list of selectable reasons shown in the bad-response popover.
 *  Keep ≤12 items — more than that makes the chip grid visually noisy. */
export const FEEDBACK_REASONS: FeedbackReason[] = [
  { id: "incorrect", label: "Incorrect answer" },
  { id: "incomplete", label: "Incomplete response" },
  { id: "hallucination", label: "Hallucinated information" },
  { id: "wrong_code", label: "Wrong code changes" },
  { id: "poor_code", label: "Poor code quality" },
  { id: "didnt_solve", label: "Didn't solve my request" },
  { id: "bad_explanation", label: "Bad explanation" },
  { id: "formatting", label: "Formatting issue" },
  { id: "tool_issue", label: "Tool or context issue" },
  { id: "other", label: "Other" },
];

export const FEEDBACK_COMMENT_MAX_LENGTH = 2000;

/** Numeric ratings sent to the feedback API. 1–5 scale. */
export const FEEDBACK_RATING = {
  POSITIVE: 5,
  NEGATIVE: 1,
} as const;

/** Analytics event names — ready to wire into PostHog / Amplitude / custom. */
export const FEEDBACK_EVENTS = {
  OPENED: "weave_feedback_opened",
  CANCELLED: "weave_feedback_cancelled",
  SUBMITTED: "weave_feedback_submitted",
  THUMBS_UP: "weave_feedback_thumbs_up",
} as const;
